export const BALANCE_TYPES = {
  STATEBALANCE: "[STATUS] BALANCE"
};
